import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';

/**
 * Dashboard page - navigation hero cards
 */
export default function Dashboard() {
    const navigate = useNavigate();
    const [loading] = useState(false);

    return (
        <div className="w-full space-y-8">
            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Central Product Master Hero Card */}
                <div
                    onClick={() => navigate('/central-product-master')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#f43f5e] to-[#fb7185] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">Catalog</span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Product Master
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Review catalog health, verification queues, and manage the
                                    central product master.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/central-product-master');
                                    }}
                                    className="bg-white text-[#f43f5e] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    Open Product Master
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Store Management Hero Card */}
                <div
                    onClick={() => navigate('/store-management')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#f59e0b] to-[#fbbf24] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">Management</span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Stores
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Manage store live statuses. Set stores as Live or Trial with a
                                    single click.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/store-management');
                                    }}
                                    className="bg-white text-[#f59e0b] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    Manage Stores
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Reports Hero Card */}
                <div
                    onClick={() => navigate('/reports')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#10b981] to-[#34d399] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">
                                    Configuration
                                </span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Report Templates
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Catalogue, templates, and store-brand assignment — every report,
                                    then which store brands have them on and which stores don't have them.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/reports');
                                    }}
                                    className="bg-white text-[#10b981] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    Configure Reports
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Config templates Hero Card */}
                <div
                    onClick={() => navigate('/config-templates/brand-level')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0f766e] to-[#2dd4bf] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>
                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <span className="text-sm font-medium text-white">Settings</span>
                            </div>
                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Settings Templates
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Templates of recommended settings for onboarding new stores.
                                </p>
                            </div>
                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/config-templates/brand-level');
                                    }}
                                    className="bg-white text-[#0f766e] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    Open Settings Templates
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* AI Purchase Numbers Hero Card */}
                <div
                    onClick={() => navigate('/ai-purchase-numbers')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#14b8a6] to-[#2dd4bf] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">Insights</span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    AI Purchase Adoption
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Track adoption of the AI purchase flow across UP, Assam,
                                    Maharashtra, Odisha and Rajasthan.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/ai-purchase-numbers');
                                    }}
                                    className="bg-white text-[#14b8a6] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    View AI Purchase Adoption
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Blogs Hero Card */}
                <div
                    onClick={() => navigate('/blogs')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0ea5e9] to-[#38bdf8] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">Content</span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Blogs
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Create and manage blog posts for your customers. Rich text
                                    editor with image uploads.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/blogs');
                                    }}
                                    className="bg-white text-[#0ea5e9] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    Manage Blogs
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Microsite Hero Card */}
                <div
                    onClick={() => navigate('/microsites')}
                    className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#6e64f0] to-[#8b7cf6] p-8 md:p-12 cursor-pointer transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] group"
                >
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 group-hover:scale-110 transition-transform duration-500"></div>
                    </div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                        {/* Left content */}
                        <div className="flex-1 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M13 10V3L4 14h7v7l9-11h-7z"
                                    />
                                </svg>
                                <span className="text-sm font-medium text-white">Quick Action</span>
                            </div>

                            <div>
                                <h1
                                    className="text-5xl md:text-6xl font-bold mb-4"
                                    style={{ color: '#ffffff' }}
                                >
                                    Microsites
                                </h1>
                                <p
                                    className="text-lg md:text-xl max-w-xl"
                                    style={{ color: '#ffffff', opacity: 0.95 }}
                                >
                                    Build beautiful, responsive microsites in minutes. Perfect for
                                    campaigns, products, or events.
                                </p>
                            </div>

                            <div>
                                <Button
                                    variant="secondary"
                                    size="large"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate('/microsites');
                                    }}
                                    className="bg-white text-[#6e64f0] hover:bg-white/90 font-semibold shadow-lg"
                                >
                                    View Microsites
                                    <svg
                                        className="w-5 h-5 ml-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </div>

                        {/* Right illustration */}
                        <div className="flex-shrink-0">
                            <div className="w-36 h-36 md:w-48 md:h-48 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                <svg
                                    className="w-20 h-20 md:w-24 md:h-24 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {loading && (
                <div className="flex items-center justify-center py-8">
                    <div className="flex items-center gap-3">
                        <div className="w-6 h-6 border-2 border-[#6e64f0] border-t-transparent rounded-full animate-spin"></div>
                        <span className="text-sm text-[#64748b]">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}
